// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect, useState } from "react"
import {
  IonBackdrop,
  IonItem,
  IonInput,
  IonLabel,
  IonList,
  IonNote,
} from "@ionic/react"
import { DeviceDetail, TransactionDetail } from "../pages"
import { CurrentUser, DeviceService, TransactionService } from "../services"

interface ContainerProps {
  nav: HTMLIonNavElement
  user: CurrentUser
}

const ExploreContainer: React.FC<ContainerProps> = ({
  nav,
  user
}) => {
  const [txid, setTxid] = useState<string>("")
  const [error, setError] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)
  const classes: string[] = []
  const devices = new DeviceService()
  const transactions = new TransactionService()

  const submit = async () => {
    if (!!loading) return
    const props: any = {}
    let component: React.FC<any> = TransactionDetail
    setLoading(true)
    props.transaction = await transactions.get(txid)
    if (props.transaction === null) {
      component = DeviceDetail
      props.device = await devices.get(txid)
    }
    if (props.device === null && props.transaction == null) {
      setError("Dit document bestaat niet of bevat geen registeerbare apparaten.")
      return
    }
    nav.push(component, {
      nav: nav,
      user: user,
      ...props
    })
    setLoading(false)
  }

  useEffect(() => {
    if (!!error) { setLoading(false) }
  }, [error])

  if (!!error) classes.push("ion-invalid")
  return (
    <div className="container">
      {(!loading) ? null : (<IonBackdrop/>)}
      <p className="page-heading">
        Welkom bij Apparaatregistratiesysteem.
        Dit systeem houdt bij welke telefoons bij welke transacties zijn betrokken, zoals
        inkoopbestellingen, verkoopbestellingen en retourzendingen.
      </p>
      <p className="page-heading">
        Scan de trace & trace code of vul handmatig een inkoopnummer, bestelnummer of retournummer in.
      </p>
      <div style={{marginTop: "22px", margin: "0 auto" ,textAlign: "left", width: "70%"}}>
        <IonList lines="inset" mode="ios">
          <IonItem  className={classes.join(' ')}>
            <IonLabel position="stacked">Trackingcode, inkoopnummer, bestelnummer of retournummer</IonLabel>
            <IonInput
              autofocus={true}
              clearInput={true}
              enterkeyhint="search"
              onKeyUp={(event) => {
                setError("")
                if (event.key !== "Enter") { return }
                submit()
              }}
              onIonChange={(event) => {
                if (!event.detail || !event.detail.value) { return }
                setTxid(event.detail.value.toUpperCase())
              }}
              readonly={loading}
              value={txid}
            />
            <IonNote
              style={{textAlign: "right", width: "100%"}}
              slot="error"
            >
              {error}
            </IonNote>
          </IonItem>
        </IonList>
      </div>
      <p style={{marginTop: "22px"}}>
        Je bent ingelogd als <span style={{color: "var(--ion-color-primary)"}}>{user.claims.email}</span>.
      </p>
    </div>
  )
}

export {ExploreContainer}
